import { useCallback } from 'react';
import { User } from '@amzn/coral_com-amazon-passportusermanagementservice';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserLocaleAction } from '../actions/userManagementActions';
import { getUserProfileInfoSelector } from '../actions/userManagementActions/selectors';

export const useUpdateUserLocale = () => {
  const dispatch = useDispatch();
  const userObject = useSelector(getUserProfileInfoSelector);

  const updateUserLocale = useCallback(
    (payload) => {
      dispatch(
        updateUserLocaleAction.request(
          User.clone({
            ...userObject,
            ...payload,
          })
        )
      );
    },
    [dispatch, userObject]
  );

  return { updateUserLocale };
};

export default useUpdateUserLocale;
